import { BhbProviderDto } from "@libs/gateways/bhb/bhbGateway.dtos.ts";
import { Model } from "@libs/models/Model.ts";
import { IRootStore } from "@shared-types/root/root-store.interface.ts";

export class BhbProvider extends Model<BhbProviderDto> {
  constructor(
    private root: IRootStore,
    dto: BhbProviderDto
  ) {
    super(dto);
  }

  get provider() {
    return this.root.core.userMap.get(this.providerId);
  }

  get providerId() {
    return this.dto.id;
  }

  get locationId() {
    return this.dto.locationId;
  }

  get firstName() {
    return this.provider?.firstName ?? "";
  }

  get lastName() {
    return this.provider?.lastName ?? "";
  }

  get displayName() {
    return this.dto.displayName;
  }

  get appointmentTypes() {
    return this.dto.appointmentTypes;
  }

  get language() {
    return this.dto.language;
  }

  get areaOfInterest() {
    return this.dto.areaOfInterest;
  }

  get profileDetail() {
    return this.dto.profileDetail;
  }

  get photoUrl() {
    return this.dto.photoUrl;
  }

  get providerOnlineStatus() {
    return this.dto.providerOnlineStatus;
  }
}
